// All middle columns are plain editable text fields except 'action' (dropdown)
const editableFields = [
    'friendlyName',
    'templateBusinessRole',
    'differentiationValue',
    'approversToAdd',
    'approversToRemove',
    'publishInASP',
    'comments',
    'action',
]

export const isEditable = (fieldName) => editableFields.includes(fieldName)

const getEditableConfig = (fieldName) => {
    if (!isEditable(fieldName)) return undefined
    return { type: 'text', placeholder: '' }
}

const colStyles = {
    color: '#282828',
    fontSize: '13px',
    minWidth: '150px',
}

const wideColStyles = {
    ...colStyles,
    minWidth: '180px',
}

const attributes = [
    // ── Frozen left ────────────────────────────────────────────────────────────
    {
        sticky: 'start',
        name: 'landscapeFriendlyName',
        sortable: true,
        sortBy: 'landscapeFriendlyName',
        label: 'Landscape',
        isEditable: false,
        hideValue: true,
        component: {
            componentName: 'Landscape',
            props: {
                statusIdProp: 'rtA_CSVInboxLandscapeStatusID',
            },
        },
        styles: {
            width: '120px',
            color: '#282828',
            fontSize: '13px',
        },
    },

    // ── Scrollable columns (all editable text) ─────────────────────────────────
    {
        name: 'friendlyName',
        sortable: true,
        sortBy: 'friendlyName',
        label: 'FriendlyName',
        isEditable: isEditable('friendlyName'),
        editableConfig: getEditableConfig('friendlyName'),
        styles: wideColStyles,
    },
    {
        name: 'templateBusinessRole',
        sortable: true,
        sortBy: 'templateBusinessRole',
        label: 'TemplateBusinessRole',
        isEditable: isEditable('templateBusinessRole'),
        editableConfig: getEditableConfig('templateBusinessRole'),
        styles: wideColStyles,
    },
    {
        name: 'differentiationValue',
        sortable: true,
        sortBy: 'differentiationValue',
        label: 'DifferentiationValue',
        isEditable: isEditable('differentiationValue'),
        editableConfig: getEditableConfig('differentiationValue'),
        styles: wideColStyles,
    },
    {
        name: 'approversToAdd',
        sortable: true,
        sortBy: 'approversToAdd',
        label: 'ApproversToAdd',
        isEditable: isEditable('approversToAdd'),
        editableConfig: getEditableConfig('approversToAdd'),
        styles: colStyles,
    },
    {
        name: 'approversToRemove',
        sortable: true,
        sortBy: 'approversToRemove',
        label: 'ApproversToRemove',
        isEditable: isEditable('approversToRemove'),
        editableConfig: getEditableConfig('approversToRemove'),
        styles: colStyles,
    },
    {
        name: 'publishInASP',
        sortable: true,
        sortBy: 'publishInASP',
        label: 'PublishInASP',
        isEditable: isEditable('publishInASP'),
        editableConfig: getEditableConfig('publishInASP'),
        styles: colStyles,
    },
    {
        name: 'comments',
        sortable: true,
        sortBy: 'comments',
        label: 'Comments',
        isEditable: isEditable('comments'),
        editableConfig: getEditableConfig('comments'),
        styles: wideColStyles,
    },
    {
        name: 'action',
        sortable: true,
        sortBy: 'action',
        label: 'Action',
        isEditable: isEditable('action'),
        editableConfig: getEditableConfig('action'),
        styles: colStyles,
    },

    // ── Frozen right ───────────────────────────────────────────────────────────
    {
        name: 'rtA_CSVInboxItemStatusName',
        sortable: true,
        sortBy: 'rtA_CSVInboxItemStatusName',
        label: 'Status',
        isEditable: false,
        hideValue: true,
        component: {
            componentName: 'InboxStatusIndicator',
            props: {
                dropdownOptionsMap: {
                    Invalid: ['Ignored'],
                    Ignored: ['Invalid'],
                },
                tooltipProp: 'rtA_CSVInboxItemStatusDescription',
                statusChangeConfig: {
                    itemIdProp: 'rtA_DerivedBusinessRoleID',
                    itemIdPayloadKey: 'rtA_DerivedBusinessRoleID',
                    statusIdPayloadKey: 'rtA_CSVInboxItemStatusID',
                    statusIdMap: {
                        'Not Validated': 1,
                        Valid: 2,
                        Invalid: 3,
                        Ignored: 4,
                        Completed: 5,
                        Error: 6,
                        'Publish Queued': 7,
                        Publishing: 8,
                    },
                },
            },
        },
        sticky: 'end',
        styles: { width: '180px' },
    },
    {
        sticky: 'end',
        styles: { width: '80px' },
        hideValue: true,
        button: { name: 'ShowHideButton' },
    },
]

export default attributes
